/* eslint-disable no-underscore-dangle */
export const isProd = () => import.meta.env.PROD;

const hasInternetAccessEnv = window.injectedEnv?.HAS_INTERNET_ACCESS === 'true';

export const hasInternetAccess = () => hasInternetAccessEnv;
